import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import {
  getComplaint,
  getComplaintMeta,
  getComplaints,
  updateComplaintStatus,
} from "api/complaintApi"

export const COMPLAINT_QUERY_KEY = "complaints"

export const useComplaints = (params = {}, enabled = true) =>
  useQuery({
    queryKey: [COMPLAINT_QUERY_KEY, "list", params],
    queryFn: () => getComplaints(params),
    enabled,
    keepPreviousData: true,
  })

export const useComplaintMeta = (enabled = true) =>
  useQuery({
    queryKey: [COMPLAINT_QUERY_KEY, "meta"],
    queryFn: getComplaintMeta,
    enabled,
    staleTime: 10 * 60 * 1000,
  })

export const useComplaint = id =>
  useQuery({
    queryKey: [COMPLAINT_QUERY_KEY, "detail", id],
    queryFn: () => getComplaint(id),
    enabled: Boolean(id),
  })

export const useUpdateComplaintStatus = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateComplaintStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [COMPLAINT_QUERY_KEY] })
    },
  })
}
